<app-menu></app-menu>
<app-locale></app-locale>
<router-outlet></router-outlet>